import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Slide } from "react-slideshow-image";

import arrow from '../../assets/icons/green-arrow.png';
import edit from '../../assets/icons/Icon-Edit.png';
import { toTitleCase, capitalize } from '../../utils/stringManipulations';

import "./TeamsSwiper.scss";

const TeamsSwiper = ({ teams, setSelectedTeam, selectedTeamIndex, onEditTeamClick }) => {
  let sliderRef;

  useEffect(() => {
    if (selectedTeamIndex !== 0) {
      sliderRef.goTo(selectedTeamIndex)
    }
  }, []);

  return (
    <div className="teams-swiper" data-testid="teams-swiper">
      <div className="teams-swiper__arrows">
        <button 
          onClick={() => sliderRef.goBack()} 
          style={{ transform: `rotateY(180deg)` }}
          data-testid="arrow-button"
        >
          <img className="teams-swiper__arrows__arrow" src={arrow} alt="" />
        </button>
        <button onClick={() => sliderRef.goNext()}>
          <img className="teams-swiper__arrows__arrow" src={arrow} alt="" />
        </button>
      </div>
      <Slide
        ref={ref => sliderRef = ref}
        transitionDuration={500}
        infinite={true}
        indicators={false}
        arrows={false}
        autoplay={false}
        onChange={(_, newIndex) => setSelectedTeam(teams[newIndex])}
      >
        {teams.map(team => {
          const { category: { name }, year } = team;
          const title = `${name} ${year - 1} - ${year}`
          return (
            <div className="teams-swiper__team-info">
              <span className="teams-swiper__team-info__team-name">{toTitleCase(team.name)}</span>
              <button 
                type="button" 
                className="teams-swiper__team-info__edit-button"
                onClick={onEditTeamClick}
                data-testid="edit-team"
              >
                <span>{capitalize(title)}</span>
                <img alt="" src={edit} className="teams-swiper__team-info__edit-button__icon"/>
              </button>
            </div>
          )
        }
        )}
      </Slide>
    </div>
  );
};

TeamsSwiper.propTypes = {
  selectedTeamIndex: PropTypes.number,
  setSelectedTeam: PropTypes.func,
  teams: PropTypes.array
};

TeamsSwiper.defaultProps = {
  selectedTeamIndex: 0,
  setSelectedTeam: () => { },
  teams: []
};

export default TeamsSwiper;